import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class OriginalsEpisodeDetails extends Resource {
  public static type = 'originals/episode_details';

  @prop
  public playlist: string;
}
